app = angular.module("seismology")
ref = firebase.database().ref()

app.factory 'Likable', ($firebaseAuth, Notification, Users) ->

  notifyLiked: ->
    console.log "notifyLiked: NOT IMPLEMENTED"
  
  toggleLike: ->
    console.log "liked", @likes    
    uid = $firebaseAuth().$getAuth().uid
    targetUid = @uid
    @likes ||= {}
    @likes[uid] = ! @likes[uid]
    @$save().then =>
      if @likes[uid]
        #Notification.postLiked(@$id, uid)
        @notifyLiked()
        Users.upvote(targetUid)
      else
        Users.downvote(targetUid)

  likeCount: ->
    return 0 unless @likes      
    count = 0
    for uid, bool of @likes
      count+=1 if bool
    count

  likedByCurrentUser: ->
    return false unless @likes
    @likes[$firebaseAuth().$getAuth().uid]
    

app.factory 'Commentable', ($firebaseObject, $firebaseArray, $firebaseAuth, Notification, Users, ImageUpload) ->

  notifyCommentCreated: (comment)->
    console.log "notifyCommentCreated: NOT IMPLEMENTED"

  notifyCommentLiked: (comment)->
    console.log "notifyCommentLiked: NOT IMPLEMENTED"

  commentArray: ->
    $firebaseArray(@$ref().child('comments'))

  latestComment: ->
    return null unless @comments
    keys = Object.keys(@comments)
    key = keys[keys.length-1]
    @comments[key]
      
  commentCount: ->
    return 0 unless @comments
    Object.keys(@comments).length

  addComment: (comment = {}) ->
    comment.uid = $firebaseAuth().$getAuth().uid
    comment.timestamp = firebase.database.ServerValue.TIMESTAMP
    comments = $firebaseArray(@$ref().child('comments'))
    comment.images ||= []
    imageList = []
    for image in comment.images
      imageList.push(file: image)
    ImageUpload.uploadImageList(imageList).then (data) =>
      console.log "image upload success"
      comment.images = (d.public_id for d in data)
      comments.$add(comment).then (created) =>
        @updateCommentCount()
        @notifyCommentCreated(created)

  updateCommentCount: ->
    comments = $firebaseArray(@$ref().child('comments'))
    comments.$loaded =>
      @commentSize = comments.length
      @rcommentSize = -comments.length
      @updateTimestamp = firebase.database.ServerValue.TIMESTAMP
      @updateRtimestamp = -Date.now()
      @$save()

  removeComment: (key) ->
    commentRef = @$ref().child('comments').child(key)
    commentObj = $firebaseObject(commentRef)
    commentObj.$remove()

  toggleLikeComment: (key)->
    commentRef = @$ref().child('comments').child(key)
    commentObj = $firebaseObject(commentRef)
    uid = $firebaseAuth().$getAuth().uid
    commentObj.$loaded =>
      targetUid = commentObj.uid
      commentObj.likes ||= {}
      commentObj.likes[uid] = !commentObj.likes[uid]
      commentObj.$save().then =>
      if commentObj.likes[uid]
        @notifyCommentLiked(commentObj)
        #Notification.commentLiked(@$id, commentObj.$id, uid)
        Users.upvote(targetUid)
      else
        Users.downvote(targetUid)

  commentLikeCount: (comment)->
    return 0 unless comment.likes  
    count = 0
    for uid, bool of comment.likes
      count+=1 if bool
    count

  commentLikedByCurrentUser: (comment) ->
    return false unless comment.likes
    comment.likes[$firebaseAuth().$getAuth().uid]


app.factory "Post", ($firebaseAuth, $firebaseObject, Users, Commentable, Likable, Notification) ->

  factory = angular.extend(angular.extend({}, Likable), Commentable)
  factory.imageCount = ->
    return 0 unless @images
    Object.keys(@images).length
  factory.isCreatedBy = (user) ->
    user.$id is @uid
  factory.getUser= ->
    Users.get(@uid)
  # override
  factory.notifyLiked = ->
    uid = $firebaseAuth().$getAuth().uid
    Notification.postLiked(@$id, uid)
  factory.notifyCommentCreated = (comment)->
    Notification.commentCreated(@$id, comment.key)
  factory.notifyCommentLiked = (comment)->
    uid = $firebaseAuth().$getAuth().uid
    Notification.commentLiked(@$id, comment.$id, uid)

  $firebaseObject.$extend(factory)


app.factory "PostList", ($firebaseArray, Post) ->

  $firebaseArray.$extend
    $$added: (snap) ->      
      new Post(snap.ref)
    $$updated: (snap)->
      @$getRecord(snap.key).$$updated(snap)
      

app.factory "PostFactory", ($firebaseObject, $firebaseArray, $firebaseAuth, ImageUpload, CurrentUser, PostList, Post, Notification) ->
  postsRef =  ref.child('posts')

  getScroll: ->
    new PostList(new firebase.util.Scroll(postsRef, 'rtimestamp'))

  getListByUid: (uid, limit=20) ->
    query = postsRef.orderByChild("uid").equalTo(uid)
    new PostList(query)

  add: (post={}, images=[]) ->
    # ブロック対象ユーザーの投稿を禁止    
    if CurrentUser.get().blocked
      return alert "質問の投稿はできません。"
    post.timestamp = firebase.database.ServerValue.TIMESTAMP
    post.rtimestamp = -Date.now()
    post.uid = CurrentUser.get().$id
    list = $firebaseArray(postsRef)
    console.log post
    if images.length > 0
      imageList = []
      for image in images        
        imageList.push(file: image)
      ImageUpload.uploadImageList(imageList)
        .then (data)->
          console.log "image upload success"
          post.images = (d.public_id for d in data)
          list.$add(post)
    else
      list.$add(post).then (postsRef) ->
        console.log postsRef

  get: (id) ->
    new Post(postsRef.child(id))


app.factory "ImageUpload", ($q, Upload, CLOUDINARY_CONFIGS) ->

  uploadImage: (file) ->
    deferred = $q.defer()
    data =
      file: file      
      'upload_preset': CLOUDINARY_CONFIGS.UPLOAD_PRESET
      'public_id': Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7)
    Upload.upload(url: CLOUDINARY_CONFIGS.UPLOAD_URL, data: data)
      .then (success)->
        console.log success
        deferred.resolve(success.data)
      .catch (err)->
        console.log err
        deferred.reject(err)
    deferred.promise

  uploadImageList: (images) ->
    promises = images.map (image) =>
      console.log "image", image
      @uploadImage(image.file, image.public_id)
    $q.all(promises)







// WEBPACK FOOTER //
// ./app/services/connect_services.coffee